import { bookActions } from '@/actions';
import { Button } from '@/components/elements/forms/buttons';
import { useBookAppointmentContext } from '@/components/modules/modals/BookAppointment/BookAppointment.hooks';
import Modal from '@/components/modules/modals/redesign/Modal/Modal';
import { useAppDispatch } from '@/hooks';
import useMobileView from '@/hooks/useMobileView';
import { __ } from '@/locale';
import { Place } from '@/types/state/shared';

const ServiceReadMoreModal = ({
  id,
  text,
  title,
  onClose,
  isOpen,
  place,
}: {
  id?: number;
  text?: string;
  title?: string;
  onClose: () => void;
  isOpen: boolean;
  place: Place;
}) => {
  const { isMobileView } = useMobileView();
  const dispatch = useAppDispatch();
  const context = useBookAppointmentContext();
  const services = place.services;
  return (
    <Modal className={`${isMobileView ? 'h-screen' : 'md:max-w-[560px]'}`} isOpen={isOpen}>
      <Modal.Content floating={!isMobileView} newDesign={true}>
        <div className={`relative flex flex-col ${isMobileView ? 'h-full w-full' : ''}`}>
          <Modal.Header newDesign={true} title={title} floating={!isMobileView} onClose={onClose} />
          <div className={`p-xl gap-lg bg-surface_l4 flex h-full flex-col ${isMobileView ? '' : 'rounded-b-lg'}`}>
            <span className="whitespace-pre-wrap">{text}</span>
            <Button
              label={__('book')}
              onClick={(e) => {
                const selectedService = services
                  .filter((category) => category.services.length > 0)
                  .flatMap((category) => category.services)
                  .find((service) => service.id === id);
                onClose();
                dispatch(bookActions.clearBook());
                dispatch(bookActions.removeEmployee());
                // @ts-ignore
                dispatch(bookActions.addService(selectedService, place));
                dispatch(bookActions.addPlace(place));
                context.open();
              }}
              block
              size="sm"
              variant={'primary'}
            />
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default ServiceReadMoreModal;
